'use client';

import { forwardRef, ReactNode } from 'react';
import * as Accordion from '@radix-ui/react-accordion';

interface AccordionHeaderProps {
  children: ReactNode;
  icon?: ReactNode;
}

export const AccordionHeader = forwardRef<
  HTMLButtonElement,
  AccordionHeaderProps
>((props, forwardedRef) => {
  const { icon, children, ...restProps } = props;

  return (
    <Accordion.Header data-element="header" data-testid="header">
      <Accordion.Trigger
        {...restProps}
        data-element="trigger"
        ref={forwardedRef}
        data-testid="trigger"
      >
        {children}

        <span aria-hidden data-element="icon" data-testid="icon">
          {icon}
        </span>
      </Accordion.Trigger>
    </Accordion.Header>
  );
});
